import React from 'react';
import { observer } from 'mobx-react-lite';
import { useMst } from '../../../models/stores/Root';
import TermsAndConditions from '../TermsAndConditions';
import ExternalLink from '../../input/ExternalLink';
import BackArrow from '../../content/BackArrow';
import CustomMessage from '../../content/CustomMessage';
import SafeAndSecureBranding from '../../content/SafeAndSecureBranding';

export const FooterTestId = 'footer-framework-content';

export type FooterProps = {
  showTermsAndConditions?: boolean;
};

const Footer: React.FC<FooterProps> = observer(
  ({ showTermsAndConditions = false }: FooterProps) => {
    const { configuration } = useMst();
    return (
      <div className="text-center" data-testid={FooterTestId}>
        {showTermsAndConditions && (
          <div className="mt-3">
            <TermsAndConditions />
          </div>
        )}
        <div className="mt-3">
          <SafeAndSecureBranding
            enableVolusionLogo={configuration.features.enableVolusionLogo}
          />
        </div>
        <div className="mt-6 mb-4">
          <ExternalLink href="/shoppingcart.asp">
            <BackArrow />
            Return to cart
          </ExternalLink>
        </div>
        {!!configuration.messages.footer && (
          <CustomMessage customMessage={configuration.messages.footer} />
        )}
      </div>
    );
  }
);

export default Footer;
